import EUJson from './eu-countries.json';

export * from './recentDevices';
export * from './safeStorage';

//! Make sure this list matches the 2-letter codes in Varnish (production.vcl)
export const EUCountries = Object.keys(EUJson);
